import { get } from "lodash";
import { useGetProfileQuery } from "~/schemas/generated/graphql";

export const checkSubdivision = () => {
  const getProfile = useGetProfileQuery({});
  return get(getProfile, "data.UserGetter.getProfile.SubdivisionId", "");
};
